/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/notification/app.notification.entry.component.ts.
 */
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {AppNotificationComponent} from './app.notification.component';
import {Notification} from '../../models/notification';

/**
 * Zweck: Beschreibt class AppNotificationEntryComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-notification-entry',
    templateUrl: 'app.notification.entry.component.html',
    styleUrls: ['app.notification.entry.component.scss'],
    standalone: false
})
export class AppNotificationEntryComponent implements OnInit {
  static id = 'AppNotificationEntryComponent';
  @Input() parent: AppNotificationComponent;
  @Input() notification: Notification;
  @Input() show_dismissable = true;
  @Input() show_seen = false;

  show = true;

/**
 * Beschreibt Methode setSeen und ihren Rückgabevertrag.
 */
  setSeen(event: Event) {
    this.parent.setSeen(event, this.notification);
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
  }

/**
 * Beschreibt Methode getText und ihren Rückgabevertrag.
 */
  getText() {
    return this.notification.getText(this.parent);
  }

/**
 * Beschreibt Methode getLabel und ihren Rückgabevertrag.
 */
  getLabel() {
    return this.notification.getLabel(this.parent);
  }

/**
 * Beschreibt Methode getIcon und ihren Rückgabevertrag.
 */
  getIcon() {
    return this.notification.getIcon(this.parent);
  }

/**
 * Beschreibt Methode navigateSeen und ihren Rückgabevertrag.
 */
  navigateSeen(event: Event) {
    event.stopImmediatePropagation();

    const url = this.notification.getUrl(this.parent.notificationService);

    this.parent.navigateSeen(this.notification, url);
  }


}
